<template>
  <div class="content">
    <!-- 列表页面（默认显示） -->
    <div v-if="!showDetail">
      <div class="record-list">
        <div
            class="record-card"
            v-for="(item,index) in list"
            @click="handleLiveClick(item)"
            :key="index"
        >
          <div
              class="card-tag"
              :class="[
                item.type === 1 ? 'tag-high' :
                item.type === 2 ? 'tag-middle' : 'tag-low'
              ]"
          >
            {{ item.type === 1 ? '高级课程' : item.type === 2 ? '中级课程' : '初级课程' }}
          </div>
          <div class="card-content">
            <div class="card-info">
              <div class="name">{{item.name}}</div>
              <p class="card-time">{{item.study_at}}学习</p>
              <p class="card-desc">{{item.remark}}</p>
            </div>
            <div class="card-cover">
              <img :src="item.cover" alt=""/>
            </div>
          </div>
        </div>
      </div>
      <div class="page" v-if="total > 0">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 详情页：完全铺满红框 -->
    <div v-else class="detail-container">
      <!-- 返回按钮 -->
      <div class="detail-back" @click="goBack">
        <i class="el-icon-arrow-left"></i> 返回列表
      </div>

      <!-- 主体红框区域（flex垂直布局，撑满剩余高度） -->
      <div class="video-wrap">
        <!-- 标题 -->
        <div class="glitch-title">
          {{detailInfo.name}}
        </div>

        <!-- 视频区域：占满红框核心区域 -->
        <div class="video-box" v-if="detailInfo.video_url">
          <video
              class="live-video"
              controls
              controlslist="nodownload noplaybackrate"
              disablePictureInPicture
              autoplay
              :src="detailInfo.video_url"
          ></video>
        </div>

        <!-- 下载按钮 -->
        <div class="download-group">
          <el-button type="primary" @click="downloadCourseware">
            培训课件下载
          </el-button>
          <el-button type="primary" @click="downloadTestPaper">
            培训检测题下载
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {trainingList, trainingInfo} from '@/api/api'

  export default {
    name: "index",
    data() {
      return {
        list: [],
        page: 1,
        limit: 10,
        total: 0,
        showDetail: false,
        detailInfo: {},
        cateids: "" // 接收分类ID
      };
    },
    mounted() {
      // 从路由获取 cateids
      this.cateids = this.$route.query.id || ""
      this.trainingList();
      console.log('12122')
    },
    watch: {
      // 监听菜单切换，自动刷新列表
      $route(to) {
        this.cateids = to.query.id || ""
        this.page = 1
        this.trainingList()
      }
    },
    methods: {
      handleSizeChange(val) {
        this.limit = val;
        this.trainingList();
      },
      handleCurrentChange(val) {
        this.page = val;
        this.trainingList();
      },
      trainingList() {
        let params = {
          page: this.page,
          limit: this.limit,
          cateids: this.cateids // 🔥 传给接口
        };
        trainingList(params).then(res => {
          this.list = res.data.list;
          this.total = res.data.page.total;
        });
      },

      handleLiveClick(item) {
        trainingInfo(item.id).then(res => {
          this.detailInfo = res.data
        })
        this.showDetail = true;
      },

      goBack() {
        this.showDetail = false;
        this.detailInfo = {};
      },

      downloadCourseware() {
        this.$confirm("确定下载培训课件？", "提示").then(() => {
          const url = this.detailInfo.courseware_url || "/file/培训课件.docx";
          this.downloadFile(url, "培训课件.docx");
        });
      },

      downloadTestPaper() {
        this.$confirm("确定下载培训检测题？", "提示").then(() => {
          const url = this.detailInfo.questions_url || "/file/培训检测题.docx";
          this.downloadFile(url, "培训检测题.docx");
        });
      },

      downloadFile(url, name) {
        const a = document.createElement("a");
        a.href = url;
        a.download = name;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.$message.success("开始下载");
      }
    }
  };
</script>

<style scoped lang="less">
  /* 列表样式保持原样 */
  .record-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    cursor: pointer;

    .record-card {
      background-color: #fff;
      border-radius: 12px;
      box-sizing: border-box;
      padding: 15px;
      border: 1px solid #f1f1f1;

      .card-tag {
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        float: left;

        &.tag-high {
          background-color: #fef2f2;
          color: #ef4444;
        }

        &.tag-middle {
          background-color: #fffbeb;
          color: #f59e0b;
        }

        &.tag-low {
          background-color: #eff6ff;
          color: #3a44f7;
        }
      }

      .card-content {
        display: flex;
        width: 100%;
        position: relative;

        .card-info {
          flex: 1;

          .name {
            font-size: 14px;
            font-weight: 500;
            color: #1e293b;
            margin: 15px 0;
            text-align: left;
          }

          .card-time {
            font-size: 12px;
            color: #94a3b8;
            margin-bottom: 15px;
            text-align: left;
          }

          .card-desc {
            font-size: 12px;
            color: #64748b;
            text-align: left;
          }
        }

        .card-cover {
          width: 80px;
          height: 80px;
          border-radius: 12px;
          position: absolute;
          top: -20px;
          right: 0;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }

  /* 详情页：撑满布局，红框效果 */
  .detail-container {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid #f1f1f1;
  }

  .detail-back {
    font-size: 16px;
    color: #409eff;
    cursor: pointer;
    padding: 24px;
    flex-shrink: 0;
    display: block;
    text-align: left;
  }

  .video-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 40px 40px;
    gap: 30px;
    min-height: 0;
    overflow: hidden;
  }

  .glitch-title {
    font-size: 24px;
    text-shadow: -1px 0 red, 1px 0 cyan, 0 1px blue;
    flex-shrink: 0;
    white-space: nowrap;
  }

  .video-box {
    width: 100%;
    max-width: 1000px;
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .live-video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    max-height: calc(70vh - 100px);
    display: block;
  }

  .download-group {
    flex-shrink: 0;
    display: flex;
    gap: 20px;
    justify-content: center;
  }
</style>
